import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { useCreateBranch } from "hooks";
import PopupConfirm from "./PopupConfirm";

const CreateBranch = ({ open, onClose }) => {
  const { t: getLabel } = useTranslation();
  const { createBranch } = useCreateBranch();

  const [packageId, setPackageId] = useState("");
  const [license, setLicense] = useState("");
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const handleCloseConfirmPopup = () => {
    setIsOpenConfirm(false);
  };

  const handleAcceptCloseDialog = () => {
    setPackageId("");
    setLicense("");
    onClose();
  };

  const handleCreateBranch = event => {
    event.preventDefault();
    createBranch({ packageId: packageId, license: license, onClose: handleAcceptCloseDialog });
  };

  const handleChangeLicense = event => {
    setLicense(event.target.value);
  };

  const handleChangePackageId = event => {
    setPackageId(event.target.value);
  };

  const handleCancelCreate = () => {
    if (!Boolean(license === "" && packageId === "")) {
      setIsOpenConfirm(true);
    } else {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal modal-blur fade show" style={{ display: "block" }} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 600 }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ fontSize: 24 }}>
                {getLabel(LangConstant.TXT_ADD_BRANCH)}
              </h5>
              <button type="button" className="btn-close" onClick={handleCancelCreate}></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleCreateBranch}>
                <div className="mb-3">
                  <label className="form-label">Package ID</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={packageId}
                    onChange={handleChangePackageId}
                    autoComplete="off"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">License Number</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={license}
                    onChange={handleChangeLicense}
                    autoComplete="off"
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={handleCancelCreate}>
                {getLabel(LangConstant.L_CANCEL_ADD_BRANCH)}
              </button>
              <button className="btn btn-primary" onClick={handleCreateBranch}>
                {getLabel(LangConstant.L_SAVE_INFO)}
              </button>
            </div>
          </div>
        </div>
      </div>
      <PopupConfirm
        open={isOpenConfirm}
        onClose={handleCloseConfirmPopup}
        onAccept={handleAcceptCloseDialog}
        title={getLabel(LangConstant.TXT_CONFIRM_CANCEL_CREATE_BRANCH)}
      />
    </>
  );
};

export default CreateBranch;
